import PrimaryButton from "../../../Components/Buttons/primary-button";

import { modalVariants } from "../../../Utils/constants";

export default function renderAvailableBalance(modalContext) {
  const { updateModalComponent, setModalVariant, setModalTitle, onModalClose } = modalContext;

  updateModalComponent(() => (
    <>
      <div className="modal-dialog-content">
        <span className="tooltip-label">What is this?</span>
        <span className="tooltip-description">
          The money you can spend right now — your current balance minus any pending transactions or holds.
        </span>
      </div>
      <div className="action-container">
        <PrimaryButton onClick={onModalClose}>Got It</PrimaryButton>
      </div>
    </>
  ));
  setModalVariant(modalVariants.tooltipDialog);
  setModalTitle("Available Balance");
}
